/**
 * Terugval voor YouTube-posters.
 *
 * We vragen YouTube om maxresdefault.jpg omdat dat scherp genoeg is voor de
 * galerij op een groot scherm. Die versie bestaat alleen niet voor video's
 * die ooit onder 720p zijn geupload, en dan krijg je een 404 en een leeg vak.
 * hqdefault.jpg bestaat altijd, dus daar vallen we op terug.
 *
 * De luisteraar staat op document in de capture-fase, omdat een error op een
 * img niet omhoog bubbelt. Daarna nog een ronde langs de afbeeldingen die al
 * klaar waren voordat dit script draaide.
 */
(function () {
  function vervang(img) {
    var terugval = img.dataset.kconvYtFallback;
    if (!terugval) return;
    delete img.dataset.kconvYtFallback;
    img.src = terugval;
  }

  document.addEventListener(
    'error',
    function (event) {
      var doel = event.target;
      if (doel instanceof HTMLImageElement && doel.dataset.kconvYtFallback) {
        vervang(doel);
      }
    },
    true
  );

  function inhaalronde() {
    var afbeeldingen = document.querySelectorAll('img[data-kconv-yt-fallback]');
    for (var i = 0; i < afbeeldingen.length; i++) {
      var img = afbeeldingen[i];
      // complete zonder breedte betekent mislukt, niet nog bezig.
      if (img.complete && img.naturalWidth === 0) vervang(img);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', inhaalronde);
  } else {
    inhaalronde();
  }
  window.addEventListener('load', inhaalronde);
})();
